import { lazy } from 'react';

import { Routes as RoutePaths } from 'config';
const CustomerForm = lazy(() => import('pages/auth/customer-form'));
const Login = lazy(() => import('pages/auth/login'));
const Verifyotp = lazy(() => import('pages/auth/verify-otp'));
const ResetPassword = lazy(() => import('pages/auth/reset-password'));
const ForgotPassword = lazy(() => import('pages/auth/forgot-password'));
const SubmitFeedback = lazy(() => import('pages/auth/submit-feedback'));

import App from './app';

const AppPrivate = lazy(() => import('./app-private'));

const mappedRoutes = {
  [RoutePaths.Auth.Login]: Login,
  [RoutePaths.Auth.VerifyOtp]: Verifyotp,
  [RoutePaths.Auth.ForgotPassword]: ForgotPassword,
  [RoutePaths.Auth.RegistrationForm]: CustomerForm,
  [`${RoutePaths.Auth.SubmitFeedback}/:id/:caseId`]: SubmitFeedback,
  [RoutePaths.Auth.ResetPassword]: {
    allowedForLoggedIn: true,
    Component: ResetPassword,
  },
};

export const AppTeamHospital = () => (
  <App
    PrivateApp={AppPrivate}
    mappedRoutes={mappedRoutes}
    homeRoute={RoutePaths.Home}
    authRoute={RoutePaths.Auth.Login}
  />
);
